// extracted by mini-css-extract-plugin
module.exports = {"cardFooter":"ConstructTagScores_cardFooter__1TV0a","select":"ConstructTagScores_select__1tp23","input":"ConstructTagScores_input__1Vivg"};